import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  load (e) {
    const url = e.target.dataset.url
    console.log('load')
    console.log(url)
    fetch(url)
      .then(response => response.text())
      .then((html) => {
        console.log(html)
        this.element.innerHTML = html
      })
  }
}
